import React from 'react';
import { Link } from 'react-router-dom';
import { COOKIE_PREFS_EVENT } from '../lib/cookieConsent';
import LegalLayout from '../components/LegalLayout';

const CookiePolicy: React.FC = () => (
  <LegalLayout title="Cookie Policy" lastUpdated="17 giugno 2026">
    <p>
      Questa Cookie Policy spiega cosa sono i cookie, quali strumenti utilizza il sito ChatLy (il
      «Sito») e come puoi gestire o revocare il tuo consenso in qualsiasi momento. È redatta in
      conformità alle Linee guida del Garante per la protezione dei dati personali del 10 giugno 2021
      e integra l'<Link to="/privacy">Informativa sulla Privacy</Link>.
    </p>

    <h2>1. Cosa sono i cookie</h2>
    <p>
      I cookie sono piccoli file di testo che i siti web salvano sul dispositivo dell'utente.
      Insieme ad altri strumenti analoghi (es. archiviazione locale del browser) permettono di far
      funzionare il sito, ricordare le preferenze e, previo consenso, raccogliere statistiche di
      utilizzo. I cookie possono essere «di prima parte» (impostati dal Sito) o «di terze parti»
      (impostati da servizi esterni).
    </p>

    <h2>2. Tipologie di cookie utilizzati</h2>

    <h3>2.1 Cookie tecnici (sempre attivi)</h3>
    <p>
      Necessari al funzionamento del Sito; non richiedono consenso. Includono le preferenze salvate
      nell'archiviazione locale del browser, ad esempio il tema chiaro/scuro
      (<code>chatly-theme</code>) e la scelta sui cookie (<code>chatly-cookie-consent</code>). Questi
      dati restano sul tuo dispositivo e non vengono trasmessi a terzi.
    </p>

    <h3>2.2 Cookie analitici (richiedono consenso)</h3>
    <p>
      Utilizziamo <strong>Google Analytics 4</strong> (Google Ireland Ltd. / Google LLC) per
      analizzare in forma aggregata l'utilizzo del Sito e migliorarlo. Questi cookie vengono attivati{' '}
      <strong>solo se presti il consenso</strong> tramite il banner; in assenza di consenso lo script
      di Google non viene nemmeno caricato. È attiva l'anonimizzazione dell'indirizzo IP.
    </p>

    <div className="my-4 overflow-x-auto">
      <table className="w-full border-collapse text-sm">
        <thead>
          <tr className="border-b border-border text-left text-text-primary">
            <th className="py-2 pr-4 font-semibold">Cookie</th>
            <th className="py-2 pr-4 font-semibold">Finalità</th>
            <th className="py-2 pr-4 font-semibold">Durata</th>
            <th className="py-2 font-semibold">Titolare</th>
          </tr>
        </thead>
        <tbody className="text-text-secondary">
          <tr className="border-b border-border/60">
            <td className="py-2 pr-4 align-top">_ga</td>
            <td className="py-2 pr-4 align-top">Distinzione degli utenti</td>
            <td className="py-2 pr-4 align-top">~13 mesi</td>
            <td className="py-2 align-top">Google</td>
          </tr>
          <tr className="border-b border-border/60">
            <td className="py-2 pr-4 align-top">_ga_&lt;ID&gt;</td>
            <td className="py-2 pr-4 align-top">Mantenimento dello stato della sessione</td>
            <td className="py-2 pr-4 align-top">~13 mesi</td>
            <td className="py-2 align-top">Google</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h3>2.3 Cookie di profilazione/marketing</h3>
    <p>
      <strong>Non utilizziamo</strong> cookie di profilazione, di remarketing o di marketing, né
      collaboriamo con piattaforme pubblicitarie.
    </p>

    <h2>3. Cookie e servizi di terze parti</h2>
    <p>
      I servizi di terze parti trattano i dati secondo le proprie informative:
    </p>
    <ul>
      <li>
        Google —{' '}
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
          policies.google.com/privacy
        </a>
        ;
      </li>
      <li>
        Meta/WhatsApp —{' '}
        <a href="https://www.whatsapp.com/legal/privacy-policy/" target="_blank" rel="noopener noreferrer">
          whatsapp.com/legal/privacy-policy
        </a>
        .
      </li>
    </ul>

    <h2>4. Come gestire il consenso</h2>
    <p>
      Alla prima visita viene mostrato un banner con i pulsanti «Accetta tutti», «Rifiuta» e
      «Personalizza» (con pari evidenza). Nessun cookie analitico è attivato senza una tua azione
      esplicita e lo scorrimento della pagina non equivale al consenso.
    </p>
    <p>
      Puoi modificare le tue scelte in qualsiasi momento tramite il pulsante{' '}
      <button
        type="button"
        onClick={() => window.dispatchEvent(new CustomEvent(COOKIE_PREFS_EVENT))}
        className="font-medium text-primary underline"
      >
        Preferenze cookie
      </button>{' '}
      (presente anche nel footer del Sito). Il consenso viene comunque richiesto nuovamente dopo
      circa 6 mesi. In aggiunta, puoi gestire o eliminare i cookie dalle impostazioni del tuo browser
      e installare il{' '}
      <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">
        componente di opt-out di Google Analytics
      </a>
      .
    </p>

    <h2>5. Aggiornamenti</h2>
    <p>
      La presente Cookie Policy può essere aggiornata; le modifiche saranno pubblicate su questa
      pagina con la relativa data. Per maggiori informazioni sul trattamento dei dati consulta la{' '}
      <Link to="/privacy">Privacy Policy</Link>.
    </p>
  </LegalLayout>
);

export default CookiePolicy;
